"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _moment = _interopRequireDefault(require("moment"));

var _backbone = _interopRequireDefault(require("backbone"));

var _config = _interopRequireDefault(require("config"));

var _Global = _interopRequireDefault(require("models/Global"));

var _GSModel = _interopRequireDefault(require("./GSModel"));

var _FieldValue = _interopRequireDefault(require("./FieldValue"));

var _FieldValueCollection = _interopRequireDefault(require("./FieldValueCollection"));

var _backboneRelational = _interopRequireDefault(require("backbone-relational"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var urlSetter = function urlSetter(value) {
  if (!value) {
    return value;
  }

  var values = [value, value + '.com', 'http://' + value, 'http://' + value + '.com'];

  for (var i in values) {
    var test = values[i];

    if (_backbone.default.Validation.patterns.url.test(test)) {
      return test;
    }
  }

  return value;
};

var RegistrationField = _backbone.default.RelationalModel.extend({
  relations: [{
    type: _backbone.default.HasMany,
    key: 'values',
    relatedModel: _FieldValue.default,
    collectionType: _FieldValueCollection.default,
    reverseRelation: {
      key: 'form'
    }
  }],
  defaults: {
    entityType: 'text',
    category: 'custom',
    values: [{}, {}],
    mandatory: false,
    must: false
  },
  fieldsMaxLength: {
    firstName: 50,
    lastName: 50,
    email: 100,
    title: 150,
    company: 150
  },
  sessionRegistrationValidationMin: null,
  initialize: function initialize() {
    _underscore.default.extend(_backbone.default.Validation.patterns, {
      twitter: /^[A-Za-z0-9_]{1,15}$/
    });
  },
  parse: function parse(response, options) {
    // Added global account verification to see if the model is in widget
    if (response.id && !_Global.default.get('account')) {
      response.id = _underscore.default.uniqueId(response.id + '_');
    }

    if (response.entityType == 'waiver') {
      response.defaultValue = response.defaultValue === 'true';
      response.waiverText = response.values && response.values[0] && response.values[0].value || '';
    }

    return response;
  },
  url: function url() {
    var accountId = _Global.default.get('account').get('id');

    var eventId = _Global.default.get('event').get('id');

    var url = "".concat(_config.default.baseUrl, "/accounts/").concat(accountId, "/events/").concat(eventId, "/forms/entity");

    if (!this.isNew()) {
      url = +"/".concat(this.get('id'));
    }

    return url;
  },
  toJSON: function toJSON(options) {
    var toJSON = _backbone.default.RelationalModel.prototype.toJSON.call(this);

    var forSave = options && _underscore.default.has(options, 'emulateJSON');

    if (forSave) {
      if (toJSON.entityType == 'waiver') {
        toJSON.values = [{
          value: toJSON.waiverText
        }];
      }
    }

    return toJSON;
  },
  setters: {
    localValues: function localValues(value) {
      if (this.get('validation') === 'email') {
        value = value ? ('' + value).trim() : value;
      }

      if (this.get('validation') === 'url') {
        value = urlSetter(value);
      }

      if (this.get('entityType') === 'utcDate') {
        if (value !== undefined && !(0, _moment.default)(value).isValid()) {
          value = 'invalidDate';
        }
      }

      if (this.get('entityType') === 'date') {
        if (value !== undefined && isNaN(value)) {
          value = 'invalidDate';
        } // catches the case when the date field if filed manually with a european format while expecting an american (24/05/1988 instead of 05/24/1988)

      }

      var submissionValues = _underscore.default.isArray(value) ? value : [value];
      this.set('submissionValues', submissionValues);
      return value;
    }
  },
  _validate: _underscore.default.wrap(_backbone.default.Model.prototype._validate, function (func, attrs, options) {
    _typeof(options) === 'object' && options.validate !== false && (options.validate = true);
    return func.call(this, attrs, options);
  }),
  isAllModelValid: function isAllModelValid(validate) {
    var values = this.get('values');
    var isAnswerValid = true;

    if (values) {
      values.each(function (answer) {
        isAnswerValid = answer.isValid(validate) && isAnswerValid;
      });
    }

    return this.isValid(validate) && isAnswerValid;
  },
  validatePatterns: {
    number: 'digits'
  },
  checkPattern: function checkPattern(value) {
    var validation = this.get('validation') || this.validatePatterns[this.get('entityType')];
    var pattern = _backbone.default.Validation.patterns[validation] ? _backbone.default.Validation.patterns[validation] : /\.*/;
    return !pattern.test(value);
  },
  checkFieldContainsUrl: function checkFieldContainsUrl(value) {
    var urlPattern = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?");
    return urlPattern.test(value);
  },
  setSessionRegistrationValidation: function setSessionRegistrationValidation(min) {
    this.sessionRegistrationValidationMin = min;
  },
  checkMaxFieldLength: function checkMaxFieldLength(attributeKey, value) {
    var maxLength = this.fieldsMaxLength[attributeKey];

    if (maxLength && value.length > maxLength) {
      return maxLength;
    }

    return false;
  },
  validation: {
    localValues: function localValues(value, attr, computedState) {
      var mandatory = this.get('mandatory');
      var isTextFieldEmpty = value === null || value === undefined || value.trim && value.trim() === '';
      var isRadioOrCheckboxUnset = value && value.length === 1 && value[0] === null;
      var isArrayFieldEmpty = _underscore.default.isArray(value) && !value.length;
      var isMandatoryAndEmpty = mandatory && (isTextFieldEmpty || isRadioOrCheckboxUnset || isArrayFieldEmpty);

      if (_Global.default.get('account')) {
        return false;
      } else if (computedState.entityType === 'waiver') {
        var isEmptyArray = value && (value.length === 0 || isRadioOrCheckboxUnset);

        if (mandatory && (isTextFieldEmpty && !computedState.defaultValue || isEmptyArray)) {
          return 'Field is required';
        }

        return false;
      } else if (computedState.attributeKey === 'sessionRegistration') {
        var min = this.sessionRegistrationValidationMin || (mandatory ? 1 : 0);

        if (min > (_underscore.default.without(value, null) || []).length) {
          return 'Please select at least ' + min + ' sessions';
        }
      } else if (isMandatoryAndEmpty) {
        return 'Field is required';
      } else if (value && value.length === 0 && !mandatory) {
        return false;
      } else if (value && this.checkPattern(value) || value === 'invalidDate') {
        return 'Field is invalid';
      } else if (value && computedState.attributeKey === 'firstName' && this.checkFieldContainsUrl(value)) {
        return 'Field cannot contain URL';
      } else if (value && computedState.attributeKey === 'lastName' && this.checkFieldContainsUrl(value)) {
        return 'Field cannot contain URL';
      }

      var fieldExceedsCharLimit = value && this.checkMaxFieldLength(computedState.attributeKey, value);

      if (fieldExceedsCharLimit) {
        return "Field has a limit of ".concat(fieldExceedsCharLimit, " characters");
      }
    }
  }
});

_GSModel.default.mixin.addToModel(RegistrationField);

var _default = RegistrationField;
exports.default = _default;